import { swalFireError, swalFireSuccess } from "../../admin/sweet-alert.js";
document.addEventListener("DOMContentLoaded", () => {
    const {
        csrfToken,
        isStripeEnabled,
        stripeApiKey,
        threeDSversion,
        btnLabel,
        bypassRecaptcha,
        pageName,
        successPageUrl,
        isGiftAidEnabled,
        giftAidPercentage,
        directDebitRoute,
        createPaymentIntentRoute: configCreatePaymentIntentRoute,
    } = window.config;
    const rawAmountInput = document.querySelector('input[name="rawAmount"]');
    const amountInput = document.getElementById("amount");

    window.removeEmptyButtonContainers = function () {
        const cardPaymentSection = document.querySelector("#card_payment");
        if (!cardPaymentSection) return;

        const btnWrap = cardPaymentSection.querySelector(".btn-wrap");
        if (!btnWrap) return;

        const googlePayButton = document.querySelector("#linkPayByGooglePay");
        const applePayButton = document.querySelector("#apple-pay-button");
        const stripeGooglePay = document.querySelector("#PayByStripeGooglePay");
        const stripeApplePay = document.querySelector("#PayByStripeApplePay");

        const isVisible = (element) => {
            if (!element) return false;
            const style = window.getComputedStyle(element);
            return (
                element.offsetParent !== null &&
                style.display !== "none" &&
                style.visibility !== "hidden"
            );
        };

        const btnCols = Array.from(btnWrap.querySelectorAll(".btn-col"));

        btnCols.forEach((btnCol) => {
            /**
             * PayPal's container ships hidden and is revealed only once PayPal's own SDK
             * has upgraded the button inside it (AB#17040). Sweeping it while that is
             * still in flight would delete the control this page is waiting for.
             *
             **/
            if (btnCol.dataset.paypalPending === "true") {
                return;
            }

            const applePayBtn =
                btnCol.querySelector("#apple-pay-button") ||
                btnCol.querySelector("#PayByStripeApplePay");
            const googlePayBtn =
                btnCol.querySelector("#linkPayByGooglePay") ||
                btnCol.querySelector("#PayByStripeGooglePay");
            const payPalBtn = btnCol.querySelector("#paypal-submit");

            /**
             * A surviving, no-longer-pending PayPal button counts as visible without
             * being measured: paypal.js removes the whole container in every case where
             * PayPal cannot be offered, so reaching here means it can. How PayPal lays
             * out its own custom element is not ours to assert on.
             *
             **/
            const hasVisibleButton =
                isVisible(applePayBtn) ||
                isVisible(googlePayBtn) ||
                !!payPalBtn;

            const hasAnyButton = applePayBtn || googlePayBtn || payPalBtn;

            if (!hasAnyButton || !hasVisibleButton) {
                btnCol.remove();
            }
        });

        btnWrap.classList.remove("single-button");
    };

    if (!isStripeEnabled) {
        rawAmountInput.addEventListener("keyup", (event) => {
            const value = rawAmountInput.value;
            const isEmpty = (val) => !val || val.trim().length === 0;

            if (isEmpty(value)) {
                let amountErrorMsg = "This field is required.";

                rawAmountInput.classList.add("is-invalid", "dev-is-invalid");

                // const selectedPaymentTypeId = getCheckedRadioId();
                const selectedPaymentMethodValue = selectedPeymentMethod();

                if (selectedPaymentMethodValue === "direct_debit") {
                    amountErrorMsg =
                        "This field is required - the minimum required is £1.01";
                } else {
                    const stripeEnabled =
                        document.getElementById("stripe_enabled");
                    if (stripeEnabled && stripeEnabled.value != 1) {
                        amountErrorMsg =
                            "This field is required - the minimum required is £0.01";
                    }
                }

                const errorContainer = document.querySelector(
                    ".dev-customer-rawAmount",
                );
                if (errorContainer) {
                    errorContainer.innerHTML = amountErrorMsg;
                }
            } else {
                if (
                    typeof getMinCurrencyAmount === "function" &&
                    getMinCurrencyAmount()
                ) {
                    rawAmountInput.classList.remove("is-invalid");
                    if (typeof checkforValidationMessage === "function") {
                        checkforValidationMessage();
                    }
                }
            }
        });

        /* -------------------------------
         * Amount processing + key filtering
         * ------------------------------- */
        rawAmountInput.addEventListener("keyup", (event) => {
            const numericValue =
                parseFloat(rawAmountInput.value.replace(",", ".")) || 0;

            amountInput.value = Math.round(numericValue * 100);

            // Calculate gift aid if enabled and checkbox is checked
            const giftAidDisplay = document.querySelector(
                "input#gift_aid_display",
            );
            if (giftAidDisplay?.checked) {
                if (typeof calculateGiftAidAmount === "function") {
                    calculateGiftAidAmount();
                } else if (typeof calculate_gift_aid_amount === "function") {
                    calculate_gift_aid_amount();
                }
            } else if (
                document.querySelector("input#gift_aid_display_pay_by_bank")
                    ?.checked &&
                typeof calculate_gift_aid_amount_pay_by_bank === "function"
            ) {
                calculate_gift_aid_amount_pay_by_bank();
            }

            // Prevent shift key
            if (event.shiftKey) {
                event.preventDefault();
                return;
            }

            // Allow only numeric + control keys
            const allowedKeys = [
                8,
                9,
                37,
                39,
                46, // backspace, tab, arrows, delete
                110,
                190, // decimal
            ];

            if (
                (event.keyCode >= 48 && event.keyCode <= 57) || // numbers
                (event.keyCode >= 96 && event.keyCode <= 105) || // numpad
                allowedKeys.includes(event.keyCode)
            ) {
                // allowed
            } else {
                event.preventDefault();
                return;
            }

            // Limit decimals to 2 places
            const value = rawAmountInput.value;
            const [beforeDecimal, afterDecimal] = value.split(".");

            if (afterDecimal && afterDecimal.length > 2) {
                rawAmountInput.value =
                    beforeDecimal + "." + afterDecimal.substring(0, 2);
            }
        });

        $(document).ready(function () {
            var $form1 = $("#form1");
            var auto = {
                autoSetup: true, // Auto setup the form creating all hosted fields (default)
                autoSubmit: true, // Auto validate, tokenize and submit the form (default)
                fields: {
                    any: {
                        nativeEvents: true,
                    },
                    cardNumber: {
                        required: true,
                        validationMessages: {
                            required: "Card number is missing",
                        },
                    },
                    cardExpiryDate: {
                        required: true,
                        validationMessages: {
                            required: "Expiry date is missing",
                        },
                    },
                    cardCVV: {
                        required: true,
                        validationMessages: {
                            required: "CVV is missing",
                        },
                    },
                    cardDetails: {
                        required: true,
                    },
                },
            };

            try {
                var hf = $form1.hostedForm(auto);
            } catch (e) {
                if (console && console.log) {
                    console.log("Failed to create hosted form 1: " + e);
                }
                throw e; // Can't continue with this script
            }

            hf.on({
                "hostedform:beforeSubmit": function () {
                    //setDeviceFields();
                    return false;
                },
                "hostedfield:valid": function (event) {
                    btnSubmit.disabled = false;
                    return;
                },
                "hostedform:invalid": function (event) {
                    grecaptcha.reset();
                    return;
                },
                "hostedform:valid": function (event) {
                    const selectedPaymentMethodValue = selectedPeymentMethod();
                    btnSubmit.disabled = true;

                    if (selectedPaymentMethodValue == "card_payment") {
                        //setDeviceFields();
                        return;
                    } else if (selectedPaymentMethodValue === "bank_payment") {
                        processOpenBankingPayment();
                        return false;
                    }
                },
                "hostedform:error": function (event) {
                    const selectedPaymentMethodValue = selectedPeymentMethod();
                    btnSubmit.disabled = false;
                    if (selectedPaymentMethodValue == "card_payment") {
                        grecaptcha.reset();
                        return;
                    } else if (selectedPaymentMethodValue === "bank_payment") {
                        processOpenBankingPayment();
                        return false;
                    }
                },
            });
        });
    } else {
        var stripe = Stripe(stripeApiKey, {
            stripeAccount: document.querySelector(
                "input[name=stripe_account_id]",
            ).value,
        });
        initStripe(stripeApiKey);
        initStripe(stripeApiKey);

        function initStripe(key) {
            inputMasking();
            var elements = stripe.elements();
            var style = {
                base: {
                    iconColor: "#6372A7",
                    color: "#142253",
                    fontWeight: 400,
                    fontFamily: "Source Sans Pro, sans-serif",
                    fontSize: "16px",
                    "::placeholder": {
                        color: "#6372A7",
                    },
                },
            };

            const cardNumberElement = elements.create("cardNumber", {
                style: style,
                classes: {
                    base: "form-control", // normal state
                },
                placeholder: "1234 1234 1234 1234",
            });
            cardNumberElement.mount("#card-number-element");

            var cardExpiryElement = elements.create("cardExpiry", {
                style: style,
                classes: {
                    base: "form-control", // normal state
                },
                placeholder: "MM / YY",
            });
            cardExpiryElement.mount("#card-expiry-element");

            var cardCvcElement = elements.create("cardCvc", {
                style: style,
                classes: {
                    base: "form-control", // normal state
                },
                placeholder: "000",
            });
            cardCvcElement.mount("#card-cvc-element");

            cardNumberElement.on("ready", function (event) {
                // Handle ready event
                $("#card-number-element").find("iframe").attr("title", "");
            });
            cardExpiryElement.on("ready", function (event) {
                // Handle ready event
                $("#card-expiry-element").find("iframe").attr("title", "");
            });
            cardCvcElement.on("ready", function (event) {
                // Handle ready event
                $("#card-cvc-element").find("iframe").attr("title", "");
            });

            cardNumberElement.on("change", (event) => {
                handleError(event, "#card-number-element");
            });
            cardExpiryElement.on("change", (event) => {
                handleError(event, "#card-expiry-element");
            });
            cardCvcElement.on("change", (event) => {
                handleError(event, "#card-cvc-element");
            });

            function handleError(event, elementSelector) {
                const wrapper = document
                    .querySelector(elementSelector)
                    ?.closest(".input-wrapper");
                if (!wrapper) return;

                let errorEl = wrapper.querySelector(".js-stripe-error");

                if (event.error) {
                    if (!errorEl) {
                        errorEl = document.createElement("div");
                        errorEl.className =
                            "js-stripe-error text-danger mt-1 small";
                        wrapper.appendChild(errorEl);
                    }
                    errorEl.textContent = event.error.message;
                    wrapper.classList.add("has-error");
                    return;
                }

                // No error — clear inline message
                if (errorEl) {
                    errorEl.remove();
                }
                wrapper.classList.remove("has-error");
                btnSubmit.innerHTML = btnLabel;
                btnSubmit.disabled = false;
            }

            btnSubmit.addEventListener("click", function (ev) {
                ev.preventDefault();
                console.log("ok");

                const selectedPaymentMethod = document.querySelector(
                    'input[name="payment_method"]:checked',
                );
                const selectedPaymentMethodValue = selectedPaymentMethod
                    ? selectedPaymentMethod.value
                    : null;

                btnSubmit.disabled = true;
                //btnSubmit.innerHTML = btnProcessingLabel;

                if (bypassRecaptcha) {
                    onSubmit("bypass-recaptcha");
                }

                if (selectedPaymentMethodValue == "card_payment") {
                    createPaymentMethod(cardNumberElement).then(
                        async (payment_method) => {
                            if (!payment_method) {
                                return false;
                            }

                            let initialIntent =
                                await createStripeIntent(payment_method);
                            if (initialIntent) {
                                return confirmCardPayment(payment_method);
                            }

                            let failedIntent =
                                await createFailedStripeIntent(payment_method);
                            if (!failedIntent) {
                                swalFireError(
                                    "Something went wrong while creating a payment intent.",
                                );
                                return false;
                            }

                            let clientSecret = $("#client_secret").val();
                            if (!clientSecret) {
                                swalFireError("Card details are not present");
                                return false;
                            }

                            return confirmCardPayment({
                                card: cardNumberElement,
                                billing_details: {
                                    address: {
                                        line1: document.querySelector(
                                            'input[name="customerAddress"]',
                                        ).value,
                                        postal_code: document.querySelector(
                                            'input[name="customerPostCode"]',
                                        ).value,
                                    },
                                    name: document.querySelector(
                                        'input[name="customerName"]',
                                    ).value,
                                    email: document.querySelector(
                                        'input[name="customerEmail"]',
                                    ).value,
                                },
                            });
                        },
                    );
                } else if (selectedPaymentMethodValue == "bank_payment") {
                    processOpenBankingPayment();
                }
            });
        }

        function confirmCardPayment(payment_method) {
            const clientSecret = document.querySelector("#client_secret").value;

            stripe
                .confirmCardPayment(clientSecret, {
                    payment_method: payment_method,
                })
                .then(function (result) {
                    if (result.error) {
                        if (result.error.payment_intent) {
                            btnSubmit.value = "Please Wait...";
                            document.querySelector(
                                "#payment_intent_status",
                            ).value = result.error.payment_intent.status;
                            document.querySelector("#stripe_error_msg").value =
                                result.error.message;
                            btnSubmit.setAttribute("type", "submit");
                            localStorage.setItem("stripeStatus", "true");
                            onSubmit();
                        } else {
                            const errorElement =
                                document.querySelector(".error");
                            // errorElement.textContent = result.error.message;
                            errorElement.classList.add("visible");
                            return false;
                        }
                    } else {
                        btnSubmit.value = "Please Wait...";
                        document.querySelector("#payment_intent_status").value =
                            result.paymentIntent.status;
                        btnSubmit.setAttribute("type", "submit");

                        //btnSubmit.innerHTML = btnProcessingLabel;
                        btnSubmit.disabled = true;

                        localStorage.setItem("stripeStatus", "true");
                        onSubmit();
                    }
                });
        }

        async function createPaymentMethod(cardNumberElement) {
            const name = document.querySelector(
                'input[name="customerName"]',
            ).value;
            const email = document.querySelector(
                'input[name="customerEmail"]',
            ).value;

            const res = await stripe.createPaymentMethod({
                type: "card",
                card: cardNumberElement,
                billing_details: { name, email },
            });

            if (res.error) {
                swalFireError(res.error.message);
                throw new Error("Payment method creation failed");
            }

            return res.paymentMethod.id;
        }

        function getAmountAndCurrency() {
            const amountField = document.querySelector("#rawAmount");
            const currencyField = document.querySelector(
                'select[name="currencyCode"], input[name="currencyCode"]',
            );

            return {
                amount: amountField ? amountField.value : "",
                currency: currencyField ? currencyField.value : "",
            };
        }

        function getPaylinkAction() {
            const paylinkActionField = document.querySelector(
                'input[name="paylinkAction"]',
            );
            return paylinkActionField ? paylinkActionField.value : "";
        }

        function getCreatePaymentIntentRoute() {
            return (
                configCreatePaymentIntentRoute ||
                window.createPaymentIntentRoute ||
                ""
            );
        }

        async function createFailedStripeIntent(paymentMethodId) {
            const { amount, currency } = getAmountAndCurrency();

            if (!amount || !currency) {
                return false;
            }

            const transactionUniqueField = document.querySelector(
                'input[name="transactionUnique"]',
            );
            const transactionUnique = transactionUniqueField
                ? transactionUniqueField.value
                : "";

            const payload = {
                amount: amount,
                currency: currency,
                accountId: document.querySelector("#stripe_account_id").value,
                transactionUnique: transactionUnique,
                paylinkAction: getPaylinkAction(),
                paymentMethodId,
                intentStatus: false,
            };

            const paymentIntentRoute = getCreatePaymentIntentRoute();
            if (!paymentIntentRoute) {
                return false;
            }

            const response = await fetch(paymentIntentRoute, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken,
                    Accept: "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (data.success) {
                document.querySelector("#payment_intent").value =
                    data.payment_intent;
                document.querySelector("#client_secret").value =
                    data.client_secret;
                document.querySelector("#stripe_charge_id").value =
                    data.intent_response.latest_charge ?? null;
                document.querySelector("#currency_name").value =
                    data.currency_name;
                document.querySelector("#payment_method_id").value =
                    paymentMethodId;

                return true;
            }

            if (data?.error?.message) {
                return false;
            }
        }

        async function createStripeIntent(paymentMethodId) {
            const { amount, currency } = getAmountAndCurrency();

            if (!amount) {
                swalFireError("Amount is required");
                return false;
            }

            if (!currency) {
                swalFireError("Currency is required");
                return false;
            }

            const transactionUniqueField = document.querySelector(
                'input[name="transactionUnique"]',
            );
            const transactionUnique = transactionUniqueField
                ? transactionUniqueField.value
                : "";

            const payload = {
                amount: amount,
                currency: currency,
                accountId: document.querySelector("#stripe_account_id").value,
                transactionUnique: transactionUnique,
                paylinkAction: getPaylinkAction(),
                paymentMethodId,
                intentStatus: true,
            };

            const paymentIntentRoute = getCreatePaymentIntentRoute();
            if (!paymentIntentRoute) {
                swalFireError("Unable to initialize payment route");
                return false;
            }

            try {
                const response = await fetch(paymentIntentRoute, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-TOKEN": csrfToken,
                        Accept: "application/json",
                    },
                    body: JSON.stringify(payload),
                });

                const data = await response.json();

                if (data.success) {
                    document.querySelector("#payment_intent").value =
                        data.payment_intent;
                    document.querySelector("#client_secret").value =
                        data.client_secret;
                    document.querySelector("#stripe_charge_id").value =
                        data.intent_response.latest_charge ?? null;
                    document.querySelector("#currency_name").value =
                        data.currency_name;
                    document.querySelector("#payment_method_id").value =
                        paymentMethodId;

                    return true;
                }

                if (data?.error?.message) {
                    return false;
                }
            } catch (error) {
                return false;
            }
        }

        var userAgent = navigator.userAgent.toLowerCase();
        var isSafari =
            /safari/.test(userAgent) && /apple computer/.test(navigator.vendor);

        if (isSafari) {
            //Stripe apple pay integration

            const expressAppleCheckoutOptions = {
                buttonType: {
                    applePay: "buy",
                },
                buttonTheme: {
                    applePay: "black",
                },
            };
            const appleElements = stripe.elements({
                mode: "payment",
                amount: 1099,
                currency: "gbp",
            });
            const expressAppleCheckoutElement = appleElements.create(
                "expressCheckout",
                expressAppleCheckoutOptions,
            );
            expressAppleCheckoutElement.mount("#PayByStripeApplePay");

            setTimeout(() => {
                if (typeof window.removeEmptyButtonContainers === "function") {
                    window.removeEmptyButtonContainers();
                }
            }, 100);

            expressAppleCheckoutElement.on("click", (event) => {
                if (
                    $("input[name=rawAmount]").val() == "" ||
                    $("input[name=rawAmount]").val() < 1
                ) {
                    swalFireError("Amount is required");
                    return;
                }
                if ($("#client_secret").val() == "") {
                    swalFireError("Amount is required");
                    return;
                }
                var updatedAmount = $("input[name=rawAmount]").val() * 100;
                var currencyCode = $("select[name=currencyCode]").val();
                var updatedCurrency = currencySet
                    .find((item) => item.key === Number(currencyCode))
                    ?.text.toLowerCase();
                appleElements.update({
                    amount: updatedAmount,
                    currency: updatedCurrency,
                });
                const appleOptions = {
                    business: {
                        name: pageName,
                    },
                    emailRequired: true,
                };
                event.resolve(appleOptions);
            });
            const handleAppleError = (error) => {
                const appleMessageContainer = document.querySelector(
                    "#apple-error-message",
                );
                appleMessageContainer.textContent = error.message;
            };

            expressAppleCheckoutElement.on("confirm", async (event) => {
                const { error: submitError } = await appleElements.submit();
                if (submitError) {
                    swalFireError(submitError);
                    return;
                }

                const appleClientSecret = $("#client_secret").val();
                const { appleError } = await stripe.confirmPayment({
                    // `elements` instance used to create the Express Checkout Element
                    appleElements,
                    // `clientSecret` from the created PaymentIntent
                    appleClientSecret,
                    redirect: "if_required",
                    confirmParams: {
                        return_url: successPageUrl,
                    },
                });

                if (error) {
                    handleAppleError(error);
                    return;
                } else {
                    swalFireSuccess("Payment successful");
                    $("#payment_intent_status").val("succeeded");
                    $("#stripePaymentMethod").val("applepay");
                    $("#btnSubmit").attr("type", "submit");
                    $("#form1").submit();
                }
            });
        } else {
            const expressCheckoutOptions = {
                buttonType: {
                    googlePay: "buy",
                },
                buttonTheme: {
                    googlePay: "black",
                },
            };
            const elements = stripe.elements({
                mode: "payment",
                amount: 1099,
                currency: "gbp",
            });
            const expressCheckoutElement = elements.create(
                "expressCheckout",
                expressCheckoutOptions,
            );
            expressCheckoutElement.mount("#PayByStripeGooglePay");

            setTimeout(() => {
                if (typeof window.removeEmptyButtonContainers === "function") {
                    window.removeEmptyButtonContainers();
                }
            }, 100);

            expressCheckoutElement.on("click", (event) => {
                if (
                    $("input[name=rawAmount]").val() == "" ||
                    $("input[name=rawAmount]").val() < 1
                ) {
                    swalFireError("Amount is required");
                    return;
                }
                var updatedAmount = $("input[name=rawAmount]").val() * 100;
                var currencyCode = $("select[name=currencyCode]").val();
                var updatedCurrency = currencySet
                    .find((item) => item.key === Number(currencyCode))
                    ?.text.toLowerCase();

                elements.update({
                    amount: updatedAmount,
                    currency: updatedCurrency,
                });
                const options = {
                    business: {
                        name: pageName,
                    },
                    emailRequired: true,
                };
                event.resolve(options);
            });
            const handleError = (error) => {
                const messageContainer =
                    document.querySelector("#error-message");
                messageContainer.textContent = error.message;
            };

            expressCheckoutElement.on("confirm", async (event) => {
                const { error: submitError } = await elements.submit();
                if (submitError) {
                    swalFireError(submitError);
                    return;
                }
                const clientSecret = $("#client_secret").val();
                const { error } = await stripe.confirmPayment({
                    // `elements` instance used to create the Express Checkout Element
                    elements,
                    // `clientSecret` from the created PaymentIntent
                    clientSecret,
                    redirect: "if_required",
                    confirmParams: {
                        return_url: successPageUrl,
                    },
                });

                if (error) {
                    handleError(error);
                    return;
                } else {
                    swalFireSuccess("Payment successful");
                    $("#payment_intent_status").val("succeeded");
                    $("#stripePaymentMethod").val("googlepay");
                    $("#btnSubmit").attr("type", "submit");
                    $("#form1").submit();
                }
            });
        }
    }

    function selectedPeymentMethod() {
        const selectedPaymentMethod = document.querySelector(
            'input[name="payment_method"]:checked',
        );
        return selectedPaymentMethod ? selectedPaymentMethod.value : null;
    }

    // ++++++++++++++++++++++ Gift aid :: Start ++++++++++++++++++++++ //
    if (isGiftAidEnabled === "true" || isGiftAidEnabled === true) {
        const giftAidDisplay = document.querySelector("#gift_aid_display");
        const giftAidFormDiv = document.querySelector("#dev_gift_aid_form_div");
        const giftAidTitleSelect = document.querySelector(
            "#gift_aid_customer_title",
        );
        const giftAidDisplayPayByBank = document.querySelector(
            "#gift_aid_display_pay_by_bank",
        );
        const giftAidFormDivPayByBank = document.querySelector(
            "#dev_gift_aid_form_div_pay_by_bank",
        );
        const giftAidTitleSelectPayByBank = document.querySelector(
            "#gift_aid_customer_title_pay_by_bank",
        );

        // Initialize select2 for gift aid title dropdown
        if (typeof $ !== "undefined" && giftAidTitleSelect) {
            $(giftAidTitleSelect)
                .select2({
                    theme: "bootstrap-5",
                    allowClear: false,
                    minimumResultsForSearch: Infinity,
                    width: "100%",
                })
                .on("select2:select", function (e) {
                    const selectVal = e.params.data.id;
                    const otherTitleInput = document.querySelector(
                        "#gift_aid_other_title",
                    );

                    if (otherTitleInput) {
                        if (selectVal === "Other") {
                            otherTitleInput.disabled = false;
                        } else {
                            otherTitleInput.value = "";
                            otherTitleInput.disabled = true;
                        }
                    }
                });
        }

        // Initialize select2 for gift aid title dropdown (Pay by Bank)
        if (typeof $ !== "undefined" && giftAidTitleSelectPayByBank) {
            $(giftAidTitleSelectPayByBank)
                .select2({
                    theme: "bootstrap-5",
                    allowClear: false,
                    minimumResultsForSearch: Infinity,
                    width: "100%",
                })
                .on("select2:select", function (e) {
                    const selectVal = e.params.data.id;
                    const otherTitleInput = document.querySelector(
                        "#gift_aid_other_title_pay_by_bank",
                    );

                    if (otherTitleInput) {
                        if (selectVal === "Other") {
                            otherTitleInput.disabled = false;
                        } else {
                            otherTitleInput.value = "";
                            otherTitleInput.disabled = true;
                        }
                    }
                });
        }

        // Toggle gift aid form visibility
        if (giftAidDisplay && giftAidFormDiv) {
            giftAidDisplay.addEventListener("change", function () {
                if (this.checked) {
                    this.value = "y";
                    giftAidFormDiv.classList.remove("d-none");
                } else {
                    this.value = "n";
                    giftAidFormDiv.classList.add("d-none");
                }
                if (typeof calculateGiftAidAmount === "function") {
                    calculateGiftAidAmount();
                }
            });
        }

        // Toggle gift aid form visibility (Pay by Bank)
        if (giftAidDisplayPayByBank && giftAidFormDivPayByBank) {
            giftAidDisplayPayByBank.addEventListener("change", function () {
                if (this.checked) {
                    this.value = "y";
                    giftAidFormDivPayByBank.classList.remove("d-none");
                } else {
                    this.value = "n";
                    giftAidFormDivPayByBank.classList.add("d-none");
                }
                if (
                    typeof calculate_gift_aid_amount_pay_by_bank === "function"
                ) {
                    calculate_gift_aid_amount_pay_by_bank();
                }
            });
        }

        // Calculate gift aid amount function
        window.calculateGiftAidAmount = function () {
            const rawAmountInput = document.querySelector("#rawAmount");
            if (!rawAmountInput) return;

            const rawAmountVal =
                rawAmountInput.value !== ""
                    ? parseFloat(rawAmountInput.value)
                    : 0;
            const giftAidPercentageVal = parseFloat(giftAidPercentage) || 25;
            const giftAidAmount = (giftAidPercentageVal / 100) * rawAmountVal;
            const giftAidTotalAmount = rawAmountVal + giftAidAmount;

            const transactionAmountInput = document.querySelector(
                "#gift_aid_transaction_amount",
            );
            const giftAidAmountInput =
                document.querySelector("#gift_aid_amount");
            const giftAidTotalAmountInput = document.querySelector(
                "#gift_aid_total_amount",
            );
            const giftAidTotalSpan = document.querySelector(
                "#gift_aid_total_span",
            );
            const giftAidAmtBreak = document.querySelector(
                "#gift_aid_amt_break",
            );

            if (transactionAmountInput) {
                transactionAmountInput.value = rawAmountVal;
            }
            if (giftAidAmountInput) {
                giftAidAmountInput.value = giftAidAmount.toFixed(2);
            }
            if (giftAidTotalAmountInput) {
                giftAidTotalAmountInput.value = giftAidTotalAmount.toFixed(2);
            }
            if (giftAidTotalSpan) {
                giftAidTotalSpan.textContent = "£ " + rawAmountVal.toFixed(2);
            }
            if (giftAidAmtBreak) {
                giftAidAmtBreak.textContent =
                    " + £ " + giftAidAmount.toFixed(2) + " Gift Aid";
            }
        };

        // Calculate gift aid amount function (Pay by Bank)
        window.calculate_gift_aid_amount_pay_by_bank = function () {
            const rawAmountInput = document.querySelector("#rawAmount");
            if (!rawAmountInput) return;

            const rawAmountVal =
                rawAmountInput.value !== ""
                    ? parseFloat(rawAmountInput.value)
                    : 0;
            const giftAidPercentageVal = parseFloat(giftAidPercentage) || 25;
            const giftAidAmount = (giftAidPercentageVal / 100) * rawAmountVal;
            const giftAidTotalAmount = rawAmountVal + giftAidAmount;

            const transactionAmountInput = document.querySelector(
                "#gift_aid_transaction_amount_pay_by_bank",
            );
            const giftAidAmountInput = document.querySelector(
                "#gift_aid_amount_pay_by_bank",
            );
            const giftAidTotalAmountInput = document.querySelector(
                "#gift_aid_total_amount_pay_by_bank",
            );
            const giftAidTotalSpan = document.querySelector(
                "#gift_aid_total_span_pay_by_bank",
            );
            const giftAidAmtBreak = document.querySelector(
                "#gift_aid_amt_break_pay_by_bank",
            );

            if (transactionAmountInput) {
                transactionAmountInput.value = rawAmountVal;
            }
            if (giftAidAmountInput) {
                giftAidAmountInput.value = giftAidAmount.toFixed(2);
            }
            if (giftAidTotalAmountInput) {
                giftAidTotalAmountInput.value = giftAidTotalAmount.toFixed(2);
            }
            if (giftAidTotalSpan) {
                giftAidTotalSpan.textContent = "£ " + rawAmountVal.toFixed(2);
            }
            if (giftAidAmtBreak) {
                giftAidAmtBreak.textContent =
                    " + £ " + giftAidAmount.toFixed(2) + " Gift Aid";
            }
        };

        if (rawAmountInput) {
            rawAmountInput.addEventListener("input", function () {
                if (giftAidDisplay?.checked) {
                    if (typeof calculateGiftAidAmount === "function") {
                        calculateGiftAidAmount();
                    }
                }
                if (
                    giftAidDisplayPayByBank?.checked &&
                    typeof calculate_gift_aid_amount_pay_by_bank === "function"
                ) {
                    calculate_gift_aid_amount_pay_by_bank();
                }
            });
        }
    }
    // ++++++++++++++++++++++ Gift aid :: End ++++++++++++++++++++++ //

    setTimeout(() => {
        if (typeof window.removeEmptyButtonContainers === "function") {
            window.removeEmptyButtonContainers();
        }
    }, 1000);

    document.addEventListener("click", function (e) {
        if (e.target && e.target.id === "paybydirectdebit") {
            document
                .querySelectorAll(".is-invalid, .dev-is-invalid")
                .forEach((el) =>
                    el.classList.remove("is-invalid", "dev-is-invalid"),
                );

            document
                .querySelectorAll(
                    ".dev-customer-rawAmount, .dev-customer-orderRef",
                )
                .forEach((el) => (el.innerHTML = ""));
            const rawAmountInput = document.getElementById("rawAmount");
            const amount = rawAmountInput?.value;
            const orderRefInput = document.querySelector(
                'input[name="orderRef"]',
            );
            const description = orderRefInput?.value.trim();

            if (!description) {
                orderRefInput?.classList.add("is-invalid", "dev-is-invalid");

                const orderRefError = document.querySelector(
                    ".dev-customer-orderRef",
                );
                if (orderRefError) {
                    orderRefError.innerHTML = "This field is required.";
                }
                return;
            }

            if (amount === "" || Number(amount) < 1.01) {
                rawAmountInput?.classList.add("is-invalid", "dev-is-invalid");
                const errorEl = document.querySelector(
                    ".dev-customer-rawAmount",
                );
                if (errorEl) {
                    errorEl.innerHTML = "the minimum required is £1.01";
                }
                return;
            }

            const self = e.target;

            self.innerHTML = `
                <span class="spinner-border spinner-border-sm" role="status"></span>
                Redirecting...
            `;
            self.disabled = true;

            fetch(directDebitRoute, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken,
                },
                body: JSON.stringify({
                    amount,
                    description,
                }),
            })
                .then((r) => r.json())
                .then((data) => {
                    self.disabled = false;

                    if (data?.status === "success") {
                        window.location.href = data.authorisation_url;
                    }

                    if (data?.error?.message) {
                        swalFireError(data.error.message);
                        return;
                    }
                })
                .catch((err) => {
                    self.disabled = false;
                    console.error(err);
                });
        }
    });
});

function checkforValidationMessage() {
    const btnSubmit = document.querySelector("#btnSubmit");

    if (!btnSubmit) {
        return;
    }

    btnSubmit.disabled = false;
}

function getMinCurrencyAmount() {
    const stripeEnabledInput = document.getElementById("stripe_enabled");
    const rawAmountInput = document.querySelector('input[name="rawAmount"]');

    if (
        stripeEnabledInput &&
        stripeEnabledInput.value == 1 &&
        rawAmountInput &&
        rawAmountInput.value !== ""
    ) {
        const currencySelect = document.querySelector(
            'select[name="currencyCode"]',
        );
        if (!currencySelect) return true;

        const currencyCode = currencySelect.value;

        const currencyItem = currencySet.find(
            (item) => item.key === Number(currencyCode),
        );
        const currencyName = currencyItem?.text;

        const stripeCurrencyItem = stripeCurrencyArray.find(
            (item) => item.key === currencyName,
        );

        if (!stripeCurrencyItem) return true;

        const minAmount = stripeCurrencyItem.value * 0.01;

        const finalMinAmount = minAmount.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        if (parseFloat(rawAmountInput.value) < minAmount) {
            rawAmountInput.classList.add("is-invalid", "dev-is-invalid");

            const selectedOption =
                currencySelect.options[currencySelect.selectedIndex];
            const selectedText = selectedOption
                ? selectedOption.textContent.trim()
                : "";

            const amountErrorMsg =
                "This field is required - the minimum required is " +
                selectedText +
                finalMinAmount;

            const errorContainer = document.querySelector(
                ".dev-customer-rawAmount",
            );
            if (errorContainer) {
                errorContainer.innerHTML = amountErrorMsg;
            }

            const submitBtn = document.getElementById("btnSubmit");
            if (submitBtn) {
                submitBtn.disabled = true;
            }

            return false;
        }

        return true;
    }

    return true;
}

function setDeviceFields() {
    const threeDSversion = window?.config?.threeDSversion;

    if (threeDSversion && parseFloat(threeDSversion) >= 2.2) {
        const screenWidth = window?.screen?.width ?? "0";
        const screenHeight = window?.screen?.height ?? "0";
        const screenDepth = window?.screen?.colorDepth ?? "0";

        const language =
            window?.navigator?.language ||
            window?.navigator?.browserLanguage ||
            "";

        const javaEnabled =
            typeof navigator.javaEnabled === "function"
                ? navigator.javaEnabled()
                : false;

        const timezone = new Date().getTimezoneOffset();

        const setValue = (name, value) => {
            const input = document.querySelector(`input[name="${name}"]`);
            if (input) input.value = value;
        };

        setValue("deviceTimeZone", timezone);
        setValue(
            "deviceCapabilities",
            `javascript${javaEnabled ? ",java" : ""}`,
        );
        setValue("deviceAcceptLanguage", language);
        setValue(
            "deviceScreenResolution",
            `${screenWidth}x${screenHeight}x${screenDepth}`,
        );
    }
}
